import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';



function getOffset(node) {
    const { pageYOffset, pageXOffset } = global;
    const { left, bottom } = node.getBoundingClientRect();

    return {
        bottom: bottom + pageYOffset,
        left: left + pageXOffset,
    };
}

function getMousePosition(event, touchId) {
    if (event.changedTouches) {
        // event.changedTouches.findIndex(touch => touch.identifier === touchId)
        let touchIndex = 0;
        for (let i = 0; i < event.changedTouches.length; i += 1) {
            const touch = event.changedTouches[i];
            if (touch.identifier === touchId) {
                touchIndex = i;
                break;
            }
        }

        if (event.changedTouches[touchIndex]) {
            return {
                x: event.changedTouches[touchIndex].pageX,
                y: event.changedTouches[touchIndex].pageY,
            };
        }
    }

    return {
        x: event.pageX,
        y: event.pageY,
    };
}


class WordColourPickerSlider extends React.Component {

    state = {
        currentState: 'initial',
    };

    componentWillUnmount() {
        document.body.removeEventListener('mouseenter', this.handleMouseEnter);
        document.body.removeEventListener('mouseleave', this.handleMouseLeave);
        document.body.removeEventListener('mousemove', this.handleMouseMove);
        document.body.removeEventListener('mouseup', this.handleMouseUp);
    }

    handleMouseDown = (event, widget) => {
        event.preventDefault();
        this.setState({ currentState: widget });
        document.body.addEventListener('mouseenter', this.handleMouseEnter);
        document.body.addEventListener('mouseleave', this.handleMouseLeave);
        document.body.addEventListener('mousemove', this.handleMouseMove);
        document.body.addEventListener('mouseup', this.handleMouseUp);

    };

    handleDragEnd(event) {
        this.setState({ currentState: 'normal' });
        document.body.removeEventListener('mouseenter', this.handleMouseEnter);
        document.body.removeEventListener('mouseleave', this.handleMouseLeave);
        document.body.removeEventListener('mousemove', this.handleMouseMove);
        document.body.removeEventListener('mouseup', this.handleMouseUp);
        document.body.removeEventListener('touchend', this.handleTouchEnd);
    }

    handleMouseEnter = event => {
        // If the slider was being interacted with but the mouse went off the window
        // and then re-entered while unclicked then end the interaction.
        if (event.buttons === 0) {
            this.handleDragEnd(event);
        }
    };

    handleMouseLeave = event => {
        // The mouse will have moved between the last mouse move event
        // this mouse leave event
        this.handleMouseMove(event);
    };

    handleMouseUp = event => {
        this.handleDragEnd(event);
    };

    handleMouseMove = event => {
        const node = this.props.getSliderWidgetRef();
        //const { width, height } = node.getBoundingClientRect();
        const { left } = getOffset(node);
        const { x } = getMousePosition(event, this.touchId);
        const value = x - left;
        this.emitChange(event, value);
    };

    handleTouchStart = event => {
        event.preventDefault();
        const touch = event.changedTouches.item(0);
        if (touch != null) {
            this.touchId = touch.identifier;
        }
        this.setState({ currentState: 'activated' });

        const { onDragStart } = this.props;

        document.body.addEventListener('touchend', this.handleTouchEnd);

        if (typeof onDragStart === 'function') {
            onDragStart(event, 1);
        }
    };



    handleTouchMove = event => {
        if (this.touchId === undefined) {
            this.handleMouseMove(event);
        }

        for (let i = 0; i < event.changedTouches.length; i += 1) {
            const touch = event.changedTouches.item(i);
            if (touch.identifier === this.touchId) {
                this.handleMouseMove(event);
                break;
            }
        }
    };

    handleTouchEnd = event => {
        if (this.touchId === undefined) {
            this.handleMouseUp(event);
        }

        for (let i = 0; i < event.changedTouches.length; i += 1) {
            const touch = event.changedTouches.item(i);
            if (touch.identifier === this.touchId) {
                this.handleMouseUp(event);
                break;
            }
        }
    };


    emitChange(event, rawValue) {
        const { onChange, value: previousValue, letter } = this.props;

        if (rawValue !== null && rawValue !== previousValue && typeof onChange === 'function') {
            onChange(event, rawValue, this.state.currentState, letter.letterIndex);
        }
    }

    render() {

        const styles = {
            centreWidget: {
                position: 'absolute',
                borderRadius: "50%",
                width: 16,
                height: 16,
                backgroundColor: 'lightgrey'
            },
            sideWidget: {
                position: 'absolute',
                borderRadius: "50%",
                width: 10,
                height: 10,
                backgroundColor: 'lightgrey',
                top: 3
            },
            track: {
                position: 'absolute',
                height: 2,
                backgroundColor: 'darkgrey',
                top:  7
            }
        };

        const {letter, wordWidth, onClick} = this.props;

        let left = letter.leftPoint * wordWidth;
        let right = letter.rightPoint * wordWidth;
        let centre = letter.centrePoint * wordWidth;
        
        return (
            [<div key="0" style={{...styles.track, left: left, width: right-left}}></div>,
                <ButtonBase key="1"
                            style={{...styles.centreWidget, left: centre - 8}}
                            onClick={(event) => (onClick(event,letter.letterIndex))}/>,
                <ButtonBase key="2"
                            style={{...styles.sideWidget, left: left - 5}}
                            onMouseDown={(event) => this.handleMouseDown(event,'left')}
                            onTouchStartCapture={this.handleTouchStart}
                            onTouchMove={this.handleTouchMove}/>,
                <ButtonBase key="3"
                            style={{...styles.sideWidget, left: right - 5}}
                            onMouseDown={(event) => this.handleMouseDown(event,'right')}
                            onTouchStartCapture={this.handleTouchStart}
                            onTouchMove={this.handleTouchMove}/>]
                );
    }
}

export default WordColourPickerSlider;